import { render } from "./IssueArticleByline.vue?vue&type=template&id=66c36b7b"
import script from "./IssueArticleByline.vue?vue&type=script&lang=js"
export * from "./IssueArticleByline.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3963854441/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__